import {loadLazy} from 'uix/parts'

// #if process.env.UIX_PROD_CHUNKED === 'true'
const Interpreter = loadLazy(() => import(/* webpackChunkName: 'interpreter' */ './interpreter'))
// #endif
// #if process.env.UIX_PROD_CHUNKED !== 'true'
// import Interpreter from './interpreter'
// #endif
export default Interpreter
